import {combineReducers} from 'redux';
import authReducer from './authReducer';
import themeReducer from "./themeReducer";
import companyReducer from "./companyReducer";
import genericCodebookReducer from "./genericCodebookReducer";
import licenceReducer from "./licenceReducer";
import sideMenuReducer from "./sideMenuReducer";
import addLicenceReducer from "./addLicenceReducer";

export default combineReducers({
    auth: authReducer,
    theme: themeReducer,
    sideMenu: sideMenuReducer,
    company: companyReducer,
    genericCodebook: genericCodebookReducer,
    licence: licenceReducer,
    addLicence: addLicenceReducer,
});